import { ImageConstant } from '@shalina-app/shared';
import { translate, AppConstant } from '@shalina-app/shared';
import styles from './whoWrAre.module.scss';

export const WhoWeAre: React.FC<any> = () => {
  const t = translate();

  return (
    <div className={styles.whoWeAre}>
      <h2 className={styles.title}>{t(AppConstant.ABOUT_US.PG_FIRST_TITLE_FIRST)}</h2>

      <div className={styles.weAreInfo}>
        <div className={styles.weAreImg}>
          <img src={ImageConstant.SOURCE.aboutImg} alt='who we are' />
        </div>
        <div className={styles.infoText}>
          <p>{t(AppConstant.ABOUT_US.PG_FIRST_PARA_FIRST)}</p>
          <p>{t(AppConstant.ABOUT_US.PG_FIRST_PARA_TWO)}</p>
        </div>
      </div>

      <div className={styles.whyShalina}>
        <h2 className={styles.title}>{t(AppConstant.ABOUT_US.PG_FIRST_TITLE_TWO)}</h2>

        <div className={styles.whyShalinaSec}>
          <div className={styles.whyShalinacontent}>
            <h4 className={styles.subTitle}>{t(AppConstant.ABOUT_US.PRACTICAL_LEARNING)}</h4>
            <p>{t(AppConstant.ABOUT_US.PRACTICAL_LEARNING_DETAIL)}</p>
          </div>
          <div className={styles.whyShalinaImg}>
            <img src={ImageConstant.SOURCE.Practical_Learning} alt='Practical Learning' />
          </div>
        </div>

        <div className={styles.whyShalinaSec}>
          <div className={styles.whyShalinacontent}>
            <h4 className={styles.subTitle}>{t(AppConstant.ABOUT_US.KNOWLEDGE_BUILDING)}</h4>
            <p>{t(AppConstant.ABOUT_US.KNOWLEDGE_BUILDING_DETAIL)}</p>
          </div>
          <div className={styles.whyShalinaImg}>
            <img src={ImageConstant.SOURCE.Knowledge_Building} alt='Knowledge Building' />
          </div>
        </div>

        <div className={styles.whyShalinaSec}>
          <div className={styles.whyShalinacontent}>
            <h4 className={styles.subTitle}>{t(AppConstant.ABOUT_US.PRACTICE_ENHANCEMENT)}</h4>
            <p>{t(AppConstant.ABOUT_US.PRACTICE_ENHANCEMENT_DETAIL)}</p>
          </div>
          <div className={styles.whyShalinaImg}>
            <img src={ImageConstant.SOURCE.Practice_Enhancement} alt='Practice Enhancement' />
          </div>
        </div>
      </div>
    </div>
  );
};
